import { useCallback, useState } from "react";
import { TableRowNestedReactNode, TableRowNestedTable } from "../TableProps";

const useNestedTables = () => {
    const [currentExpandedRows, setCurrentExpandedRows] =
        useState<(TableRowNestedTable | TableRowNestedReactNode)[]>();

    const onExpandButtonClick = useCallback(
        (value: TableRowNestedTable | TableRowNestedReactNode) => {
            let result = currentExpandedRows ? [...currentExpandedRows] : [];

            // TODO: Create a better Identification on a row.
            const existingRow = currentExpandedRows?.find(
                (x) =>
                    `${x?.data?.[0]?.value}_${x?.data?.[1]?.value}` ===
                    `${value?.data?.[0]?.value}_${value?.data?.[1]?.value}`
            );

            if (existingRow) {
                // TODO: Create a better Identification on a row.
                result = result.filter(
                    (x) =>
                        `${x?.data?.[0]?.value}_${x?.data?.[1]?.value}` !==
                        `${value?.data?.[0]?.value}_${value?.data?.[1]?.value}`
                );
            } else {
                result.push(value);
            }

            setCurrentExpandedRows(result);
        },
        [currentExpandedRows]
    );

    return {
        currentExpandedRows,
        onExpandButtonClick,
    };
};

export default useNestedTables;
